import TypeOfField from "../../../../../FormikFields/TypeOfField"

export const renderField = (field, formik, t, disabled = false, colors) => {
    const fieldComponent = (
        <div key={field.id} className="d-flex align-items-center justify-content-between" style={{ margin: field.control === 'select' ? "10px 10px 5px" : "5px" }}>
            <TypeOfField
                formik={formik}
                control={field.control}
                label={t(field.label)}
                name={field.name}
                disabled={disabled}
                size={"small"}
                type={field.type}
                InputLabelProps={{ style: { color: colors.colorText, fontSize: 13, transformOrigin: 'top left', transform: 'translate(6px, -6px) scale(0.75)', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis'}, shrink: true }}
                noLabel={field.noLabel ?? false}
                labelPlacementEnd
                small
            />
        </div>
    )

    if (field.control === "switch" && field.label !== "enabled") {
        return <div className="position-relative d-flex align-items-center justify-content-center mx-2 mt-1" style={{ width: '100px' }}>
            {fieldComponent}
            <p className="position-absolute w-100 d-flex align-items-center justify-content-center" style={{ top: -6, margin: 0, padding: 0, fontSize: 10, opacity: 0.8, color: colors.colorText }}>{t(field.label)}</p>
        </div>
    }

    return fieldComponent
}
